(function() {
  function initInfiniteScroll() {
    const trigger = document.getElementById('infinite-scroll-trigger');
    const grid = document.querySelector('.products.products-grid');
    if (!trigger || !grid) return;

    let nextUrl = trigger.getAttribute('data-next-url');
    let isLoading = false;

    if (!nextUrl) {
      trigger.style.display = 'none';
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading && nextUrl) {
          loadMoreProducts();
        }
      });
    }, {
      rootMargin: '0px 0px 400px 0px'
    });

    observer.observe(trigger);

    async function loadMoreProducts() {
      isLoading = true;
      const loadingIndicator = trigger.querySelector('.infinite-scroll-loading');
      if (loadingIndicator) {
        loadingIndicator.style.visibility = 'visible';
      }

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');

        const newProductsGrid = doc.querySelector('.products.products-grid');
        if (newProductsGrid) {
          const newProducts = Array.from(newProductsGrid.children);
          
          if (newProducts.length > 0) {
            newProducts.forEach(product => {
              grid.appendChild(product);
            });

            if (window.jQuery && typeof window.jQuery.fn.productBox === 'function') {
              window.jQuery(newProducts).each(function() {
                window.jQuery(this).productBox();
              });
            }

            window.dispatchEvent(new Event('resize'));
          }
        }

        const newTrigger = doc.getElementById('infinite-scroll-trigger');
        nextUrl = newTrigger ? newTrigger.getAttribute('data-next-url') : null;

        if (nextUrl) {
          trigger.setAttribute('data-next-url', nextUrl);
          isLoading = false;

          try {
            const urlObj = new URL(nextUrl, window.location.origin);
            const pageParam = urlObj.searchParams.get('page');
            if (pageParam) {
              const currentPageNum = parseInt(pageParam) - 1;
              const currentUrl = new URL(window.location.href);
              currentUrl.searchParams.set('page', currentPageNum);
              window.history.replaceState(null, '', currentUrl.pathname + currentUrl.search);
            }
          } catch(e) {
            console.error('Error updating URL page state:', e);
          }
        } else {
          trigger.style.display = 'none';
          observer.disconnect();
        }

      } catch (error) {
        console.error('Error fetching next page:', error);
        isLoading = false;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId === '{{ section.id }}' || event.target.querySelector('[data-section-id="{{ section.id }}"]')) {
      initInfiniteScroll();
    }
  });
})();